import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Account from '../../../../actions/Account';
import ApiGo from '../../../../actions/ApiGo';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import { ADD_HIS_ALERTS } from '../../../../stores/reducer_HistoryData';
import WaitingIcon from '../../../Login/wait/WaitingICON';
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import RowHISBedState from './RowHISBedState';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../../stores/reducer_add';


const HISBedState =(props)=>{
    const { t } = useTranslation();
    const id = props.data.id

    const [returnShift, setReturnShift] = useState("ALL");
    const [returnState, setReturnState] = useState("all");
    const [chartOrRawData, setChartOrRawData] = useState(true);
    function toggleCorD(){setChartOrRawData(!chartOrRawData)}

    const [date, setDate] = useState("");

    // ✅ 新增：前一天的 alerts
    const [prevDayAlerts, setPrevDayAlerts] = useState([]);

    const store_timestamp = useSelector(state=>state.store_historyData.timestamp)
    const store_alerts = useSelector(state=>state.store_historyData.alerts)
    const dispatch = useDispatch()

    useEffect(() => {
        if(store_timestamp.length!==0){
            let _date_obj = new Date(store_timestamp)
            let _date = new LogTime(_date_obj).getDate()
            setDate(_date)

            // ✅ 新增：計算前一天的日期字串
            let _prevDate_obj = new Date(_date_obj)
            _prevDate_obj.setDate(_prevDate_obj.getDate() - 1)
            let _prevDate = new LogTime(_prevDate_obj).getDate()

            ApiGo.getAlert(id, _date, returnShift)
            .then(res=>{
                if(res===null || res.alerts===undefined || res.alerts.length===0){
                    dispatch(ADD_HIS_ALERTS([]))
                    return  // ✅ 加上 return，避免下面 dispatch(res.alerts) 噴錯
                };
                dispatch(ADD_HIS_ALERTS(res.alerts))
            })
            .catch(err => {
                if(err.status ===undefined ||err.statusText ===undefined){
                    err.status = 404;
                    err.statusText = "No Data";
                }
                dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"hisRec_no_data"}))
                dispatch(ADD_HIS_ALERTS([]))
            })
            .then(res=>{ dispatch(ADD_RESPONSE_JSON(res)) })

            // ✅ 新增：fetch 前一天，只是要拿 lastAlertBeforeStart 用
            ApiGo.getAlert(id, _prevDate, 'ALL')
            .then(res=>{
                if(res && res.alerts && res.alerts.length > 0){
                    setPrevDayAlerts(res.alerts)
                } else {
                    setPrevDayAlerts([])
                }
            })
            .catch(() => setPrevDayAlerts([]))
        }
    }, [returnShift, store_timestamp]);

    return(
    <>
    <UiIntegrater
        OnOff_switch={[true, true, true, true, true]}
        setReturnShift={setReturnShift}
        setReturnState={setReturnState}
        name={(props.data!==undefined)?props.data.last_name:""}
        bed={(props.data!==undefined)?props.data.first_name:""}
        />
    <div className="fx-d-c h-90">
        <div className={`fx-d-r fx-ccc ${Account.isMobileOrTablet()? "font-m":"font-ml"} frame-title _1`}>
            {Account.isMobileOrTablet()?null:
                <div className="col-2 fx-ccc row_title">{t('GLOBAL.DATE')}</div>
            }
            <div className="col-2 fx-ccc row_title">{t('GLOBAL.TIME')}</div>
            <div className="col-2 fx-ccc row_title">{t("GLOBAL.STATE")}</div>
            <div className="col-2 fx-ccc row_title">{t("GLOBAL.DESC")}</div>
            <div className="col-2 fx-ccc row_title">{t("GLOBAL.REMOVE")}</div>
            <div className="col-2 fx-ccc row_title">-</div>
        </div>
        <div className="frame-table">
            {(store_timestamp.length!==0)?
                <RowHISBedState
                    alerts={store_alerts}
                    date={date}
                    shift={returnShift}
                    state={returnState}
                    data={props.data}
                    prevDayAlerts={prevDayAlerts}  // ✅ 新增
                    />
                :<WaitingIcon page={"history"} />
            }
        </div>
    </div>
    </>
    );

}
export default HISBedState;